import React, { useEffect, useState } from "react";
import {
  TextInput,
  Label,
  LabelForm,
  FormGroup,
  FormGroupVerticalInput,
  RadioInput,
} from "..";
import { getInputErrorMessage, hasErrorInput } from "../../utils";
import Select2 from "../Select2";
import {
  getSelectedValue,
  getChildGroupOptions,
} from "../../utils/select-utils";
import { Modal } from "flowbite-react";
import { useSelector } from "react-redux";
import PageAlert from "../alerts/PageAlert";
import { Button } from "../buttons";

function MachineGroupModal({
  title,
  showModal,
  setShowModal,
  levelSelect,
  groupsList,
  groupsChildren,
  groupData,
  setModalGroupData,
  submitHandler,
  formError,
  update,
  processing,
}) {
  const [groupsOptions, setGroupOptions] = useState({});
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  useEffect(() => {
    const groupOptions = getChildGroupOptions(
      groupsChildren,
      groupData,
      groupsList
    );
    setGroupOptions(groupOptions);
  }, [groupData, groupsChildren, groupsList]);

  // Function help change option select
  function handleSelectChange(e, level) {
    const newData = { ...groupData };
    newData[level] = e.value;
    for (++level; level <= 5; level++) {
      newData[level] = 0;
    }
    setModalGroupData(newData);
  }

  const handleChangeRadio = (e) => {
    const newGroupData = { ...groupData };
    newGroupData.active = e.target.value === "true" ? true : false;
    setModalGroupData(newGroupData);
  };

  // Reset input values when the modal is closed
  const handleCloseModal = () => {
    if (processing) {
      return;
    }
    setShowModal(false);
  };

  // Function to handle changes in input
  const onChange = (e, level) => {
    setModalGroupData({ ...groupData, [level]: e.target.value });
  };
  if (!showModal) {
    return;
  }

  return (
    <form onSubmit={submitHandler}>
      <Modal show={showModal} onClose={handleCloseModal} dismissible size="2xl">
        <Modal.Header className="h-[60px] border-tenken-gray-300">
          {/* <!--Modal title--> */}
          <p className="xl:text-tenken-body font-medium leading-normal text-neutral-800 dark:text-neutral-200">
            {title}
          </p>
        </Modal.Header>
        {/* <!--Modal body--> */}
        <Modal.Body className="text-left">
          <PageAlert />
          <div className="bg-white rounded-[8px]">
            {[1, 2, 3, 4, 5].map(
              (level) =>
                groupSettings[`group_${level}`]?.active &&
                level <= levelSelect &&
                (levelSelect === level ? (
                  <FormGroup>
                    <Label
                      required
                      htmlFor={`group_${level}`}
                      className="whitespace-nowrap w-[288px]"
                    >
                      {groupSettings[`group_${level}`]?.name}
                    </Label>
                    <FormGroupVerticalInput
                      error={getInputErrorMessage(
                        formError.errors,
                        "group_" + level
                      )}
                    >
                      <TextInput
                        placeholder={groupSettings[`group_${level}`]?.name}
                        hasError={hasErrorInput(
                          formError.errors,
                          "group_" + level
                        )}
                        onChange={(e) => onChange(e, level)}
                        value={groupData[level] ? groupData[level] : ""}
                        className="w-[300px]"
                        maxLength={100}
                      />
                    </FormGroupVerticalInput>
                  </FormGroup>
                ) : (
                  <FormGroup>
                    <Label
                      required
                      htmlFor={`group_${level}`}
                      className="whitespace-nowrap w-[288px]"
                    >
                      {groupSettings[`group_${level}`]?.name}
                    </Label>
                    <FormGroupVerticalInput
                      error={getInputErrorMessage(
                        formError.errors,
                        "group_" + level
                      )}
                    >
                      <Select2
                        value={getSelectedValue(
                          groupsOptions[level],
                          groupData[level]
                        )}
                        placeholder={groupSettings[`group_${level}`]?.name}
                        options={groupsOptions[level]}
                        onChange={(e) => handleSelectChange(e, level)}
                        className="w-[300px]"
                      />
                    </FormGroupVerticalInput>
                  </FormGroup>
                ))
            )}

            <FormGroup>
              <LabelForm text="状態" className="whitespace-nowrap w-[288px]" required />
              <FormGroupVerticalInput className="xl:w-[280px] w-[280px]">
                <div className="flex items-center">
                  <div className="flex space-x-9">
                    <RadioInput
                      value={true}
                      onChange={handleChangeRadio}
                      checked={groupData.active}
                      id="valid"
                      label="有効"
                    />
                    <RadioInput
                      value={false}
                      onChange={handleChangeRadio}
                      checked={!groupData.active}
                      id="invalid"
                      label="無効"
                    />
                  </div>
                </div>
              </FormGroupVerticalInput>
            </FormGroup>
          </div>
        </Modal.Body>
        <Modal.Footer className="space-x-[32px] h-[80px]">
          <div className="w-1/2">
            <Button color="light" className="w-full" onClick={handleCloseModal}>
              閉じる
            </Button>
          </div>
          <div className="w-1/2">
            <Button
              color="primary"
              onClick={submitHandler}
              className="w-full"
              id="btn-update-group"
            >
              {update ? "更新" : "新規追加"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </form>
  );
}

export default MachineGroupModal;
